// assets
import AppStoreIcon from 'assets/AppStore.png';
import PlayStoreIcon from 'assets/PlayStore.png';
import FeedSS from 'assets/AppScreenshots/FeedSS.png';
import GroupsSS from 'assets/AppScreenshots/GroupsSS.png';
import ActivitySS from 'assets/AppScreenshots/ActivitySS.png';

// consts
import { siteMeta } from 'constant/eng';

const Home = () => {
  return (
    <div class="container pt-24 md:pt-26 px-6 mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between">
      {/* <!--Left Col--> */}
      <div class="flex flex-col w-full xl:w-2/5 justify-center lg:items-start overflow-y-hidden">
        <h1 class="my-4 text-3xl md:text-5xl text-primary font-bold leading-tight text-center md:text-left slide-in-bottom-h1">
          {siteMeta.heroTitle}
        </h1>
        <p class="leading-normal text-base md:text-lg mb-8 text-center md:text-left slide-in-bottom-subtitle">
          {siteMeta.description}
        </p>

        <p class="text-blue-400 font-bold pb-8 lg:pb-6 text-center md:text-left fade-in">
          Download our app:
        </p>
        <div class="flex w-full justify-center md:justify-start pb-24 lg:pb-0 fade-in">
          <a href="https://docs.google.com/forms/d/1YukaH-hybE0moBcYO6Mg-jT_m_vGZ-NXomrRk_Hnu1U/viewform?edit_requested=true">
            <img
              src={AppStoreIcon}
              alt="App Store"
              class="h-12 pr-4 bounce-top-icons"
            />
          </a>
          <a href="https://drive.google.com/drive/folders/1RWCHW1YwLioedSulhUpkuH4Ju-WYmIDB">
            <img
              src={PlayStoreIcon}
              alt="Play Store"
              class="h-12 bounce-top-icons"
            />
          </a>
        </div>
      </div>

      {/* <!--Right Col--> */}
      <div class="w-full xl:w-3/5 py-6 overflow-y-hidden xl:overflow-hidden flex slide-in-bottom xl:justify-end">
        <img
          src={FeedSS}
          alt="App Screenshot"
          class="max-h-[500px] object-contain"
        />
        <img
          src={ActivitySS}
          alt="App Screenshot"
          class="max-h-[500px] object-contain"
        />
        <img
          src={GroupsSS}
          alt="App Screenshot"
          class="max-h-[500px] object-contain"
        />
      </div>
    </div>
  );
};

export default Home;
